import { Route, Routes } from 'react-router'
import { AppShell } from './components/AppShell.js'
import { ProtectedRoute } from './components/ProtectedRoute.js'
import { useRealtimeEvents } from './hooks/useRealtimeEvents.js'
import { LoginPage } from './pages/LoginPage.js'
import { AuthCallbackPage } from './pages/AuthCallbackPage.js'
import { ChatPage } from './pages/ChatPage.js'
import { MemoriesPage } from './pages/MemoriesPage.js'
import { TasksPage } from './pages/TasksPage.js'
import { SessionsPage } from './pages/SessionsPage.js'
import { SettingsPage } from './pages/SettingsPage.js'
import { TracesPage } from './pages/TracesPage.js'
import { ConnectorsPage } from './pages/ConnectorsPage.js'
import { DevicesPage } from './pages/DevicesPage.js'
import { NotFoundPage } from './pages/NotFoundPage.js'

export function App() {
  // Subscribes to /api/realtime/events while logged in. Triggers voice mode
  // automatically when the bridge wake-word fires.
  useRealtimeEvents()
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />

      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AppShell>
              <ChatPage />
            </AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/memories"
        element={
          <ProtectedRoute>
            <AppShell>
              <MemoriesPage />
            </AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/tasks"
        element={
          <ProtectedRoute>
            <AppShell>
              <TasksPage />
            </AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sessions"
        element={
          <ProtectedRoute>
            <AppShell>
              <SessionsPage />
            </AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sessions/:id"
        element={
          <ProtectedRoute>
            <AppShell>
              <SessionsPage />
            </AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <AppShell>
              <SettingsPage />
            </AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/traces"
        element={
          <ProtectedRoute>
            <AppShell>
              <TracesPage />
            </AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/connecteurs"
        element={
          <ProtectedRoute>
            <AppShell>
              <ConnectorsPage />
            </AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/devices"
        element={
          <ProtectedRoute>
            <AppShell>
              <DevicesPage />
            </AppShell>
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}
